import styled, { css, keyframes } from 'styled-components';

const fadeIn = keyframes`
  from { opacity: 0; transform: translateY(-10px); }
  to { opacity: 1; transform: translateY(0); }
`;

const fadeOut = keyframes`
  from { opacity: 1; transform: translateY(0); }
  to { opacity: 0; transform: translateY(-10px); }
`;

export const ThemeSelectorContainer = styled.div`
  position: fixed;
  top: 20px;
  right: 20px;
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  gap: 10px;
  z-index: 1050;
  
  @media (max-width: 768px) {
    top: 20px;
    right: 20px;
  }
`;

export const ThemeMenu = styled.div<{ $isOpen: boolean }>`
  display: flex;
  flex-direction: column;
  gap: 10px;
  opacity: ${props => props.$isOpen ? 1 : 0};
  visibility: ${props => props.$isOpen ? 'visible' : 'hidden'};
  transform: ${props => props.$isOpen ? 'translateY(0)' : 'translateY(-10px)'};
  transition: opacity 0.3s ease, transform 0.3s ease, visibility 0.3s ease;
  animation: ${props => props.$isOpen ? fadeIn : fadeOut} 0.3s ease;
  pointer-events: ${props => props.$isOpen ? 'auto' : 'none'};
`;

export const ThemeButton = styled.button<{
  $theme: string;
  $isSelected: boolean;
  $isMainButton?: boolean;
}>`
  width: 42px;
  height: 42px;
  border-radius: 8px;
  cursor: pointer;
  padding: 0;
  font: inherit;
  transition: all 0.3s ease;
  display: flex;
  justify-content: center;
  align-items: center;
  color: white;
  border: 2px solid ${props => props.$isSelected ? 'white' : 'transparent'};
  transform: ${props => props.$isSelected ? 'scale(1.15)' : 'scale(1)'};
  box-shadow: ${props => props.$isSelected 
    ? '0 0 12px rgba(255, 255, 255, 0.6)' 
    : '0 2px 5px rgba(0, 0, 0, 0.3)'};
  
  /* Ana buton için ekstra stiller */
  ${props => props.$isMainButton && css`
    z-index: 1010;
    transform: scale(1.15);
    &:hover {
      transform: scale(1.2);
    }
  `}
  
  &:hover {
    transform: ${props => props.$isSelected ? 'scale(1.15)' : 'scale(1.1)'};
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.4);
  }
  
  &:active {
    transform: scale(0.95);
  }
  
  ${(props) => {
    switch (props.$theme) {
      case 'cmd':
        return `
          background-color: #0c0c0c;
        `;
      case 'powershell':
        return `
          background-color: #012456;
        `;
      case 'ubuntu':
        return `
          background-color: #300a24;
        `;
      default:
        return '';
    }
  }}
`; 